import { render, staticRenderFns } from "./ReportesPage.html?vue&type=template&id=a51e4a98&external"
import script from "./ReportesPage.vue?vue&type=script&lang=ts"
export * from "./ReportesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports